import React, { useLayoutEffect, useState, useEffect } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
    LoadPanel,
} from "devextreme-react/data-grid";
import { Button, DateBox, SelectBox } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import Popup from "devextreme-react/popup";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Swal from 'sweetalert2';
import { useSelector } from "react-redux";
import { IOMService } from '../../../apis/apiServices/InterOfficeMemo(IOM)'
import { ProjectService } from '../../../apis/apiServices/Project'

export default function IOMv2Component(props) {

    // console.log("props", props);

    useLayoutEffect(() => {
        document.querySelector("#pageTitle").innerHTML = "IOM - Inter Office Memorandum";
        getIOMList();
        getProjectDropdownData();
        getIOMStatusDropdownData();
        getIOMNoDropdownData(user?.userId);
    }, []);
    const [charCount, setCharCount] = useState(0);
    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: 0,
        statusId: 0,
        iomNo: 0,
    });
    const [filterErrors, setFilterErrors] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const [iomList, setIOMList] = useState(null);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("drafted");
    const [filteredList, setFilteredList] = useState(null);
    const user = useSelector((state) => state.user.data);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [error, setError] = useState({ remarks: "" });
    const [rowIOMId, setIOMId] = useState("");
    const [iomStatusDropdownData, setIOMStatusDropdownData] = useState(null);
    const [iomNoDropdownData, setIOMNoDropdownData] = useState(null);
    const [projectDropdownData, setProjectDropdownData] = useState(null);

    const getIOMList = async (isIgnoreFilters) => {
        debugger;
        try {
            setLoading(true);
            let body = {
                UserId: user.userId,
                fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
                toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
                IomId: (filters?.iomNo && isIgnoreFilters !== true) ? filters?.iomNo : 0,
                projectId: (filters?.projectId && isIgnoreFilters !== true) ? filters?.projectId : 0,
                iomStatusId: (filters?.statusId && isIgnoreFilters !== true) ? filters?.statusId : 0,
            }
            setLoading(true);
            const response = await IOMService.getIOMList(body)
            // const filteredData = response?.data?.filter(item => item?.nextUserId !== user?.userId || item?.iomStatusId === 4 || item?.iomStatusId === 9);
            const filteredData = response?.data?.filter(item =>
                (item?.nextUserId !== user?.userId || item?.iomStatusId === 4 || item?.iomStatusId === 9 || item?.iomStatusId === 8) && item?.iomStatusId !== 1
                //&& item?.isManual === false
            );
            setLoading(false);
            setLoading(false);
            setIOMList(filteredData);
            // getFilteredList([8, 4], response?.data)
            return response?.data;
        } catch (error) {
            console.log("Error getIOMList===>", error);
        }
    }

    // const getProjectDropdownData = async () => {
    //     //debugger;
    //     try {
    //         let body = {}
    //         const response = await ProjectService.getProjectDropdown(body)
    //         setProjectDropdownData(response?.data);
    //     } catch (error) {
    //         console.log("Error getProjectList===>", error);
    //     }
    // }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }

    const getIOMStatusDropdownData = async () => {
        try {
            let body = {}
            const response = await IOMService.getIOMStatusDropdown(body)
            setIOMStatusDropdownData(response?.data);
        } catch (error) {
            console.log("Error getIOMStatusDropdown===>", error);
        }
    }

    const getIOMNoDropdownData = async () => {
        //debugger;
        try {
            const response = await IOMService.getIOMNoDropdown(user?.userId)
            setIOMNoDropdownData(response?.data);
        } catch (error) {
            console.log("Error getIOMNoDropdown===>", error);
        }
    }

    const handleFilterChange = (key, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const ConvertDateToddMMyyyy = (date) => {
        if (!date) return "";

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;

        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }

    const ConvertddMMyyyyToDate = (dateStaring) => {
        if (!dateStaring) return "";
        let date = new Date(dateStaring)
    }

    // const handleRemarksChange = (e) => {
    //     setRemarks(e.value);
    //     if (error) setError(""); // clear error on typing
    // };

    const handleRemarksChange = (e) => {
        const value = e?.event?.target?.value?.slice(0, 300) || ""; // Auto-trim to 300 chars

        setRemarks(value);
        setCharCount(value.length);

        // Set error only if max limit was hit
        setError((prev) => ({
            ...prev,
            remarks: value.length >= 300
                ? "Remarks cannot exceed 300 characters"
                : "",
        }));
    };

    const handleSubmit = () => {
        const newError = {};
        if (!remarks?.trim()) {
            newError.remarks = "Please enter remarks";
        } else if (remarks?.length > 300) {
            newError.remarks = "Remarks cannot exceed 300 characters";
        } else {
            setError({ remarks: "", userIdForRejectIOM: "" });
        }

        if (Object.keys(newError).length > 0) {
            setError(newError);
            return;
        }
        setError("");
        setIsDeleteModalVisible(false);
        deleteIoM();  // Now call your existing function
    };

    const deleteIoM = async () => {
        //e.preventDefault();
        if (!remarks.trim()) {
            setError("Please enter remarks");
            return;
        }
        setIsDeleteModalVisible(false);
        setRemarks("");

        let body = {
            userId: user.userId,
            remarks: remarks || "",
            iomId: rowIOMId || 0,
        };
        const response = await IOMService.deleteIOM(body);
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            );
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => { navigate(-1) });
        getIOMList();
    };

    const getFilteredList = (iomStatusIds, newIomList) => {
        let newFilteredList = newIomList
            ? newIomList?.filter(iom => iomStatusIds?.includes(iom?.iomStatusId))
            : iomList?.filter(iom => iomStatusIds?.includes(iom?.iomStatusId))

        setFilteredList(newFilteredList);
    }

    const getPendingIOMList = (iomStatusIds, newIomList) => {
        let newFilteredList = (newIomList || iomList)?.filter(
            iom =>
                iomStatusIds?.includes(iom?.iomStatusId) &&
                iom?.nextUserId !== user?.userId // 👈 Exclude these
        );

        setFilteredList(newFilteredList);
    };

    useEffect(() => {
        switch (activeTab) {
            case "pending":
                getPendingIOMList([2, 3, 5, 7]);
                break;
            case "approved":
                getFilteredList([1]);
                break;
            default:
                getFilteredList([8, 4]);
        }

    }, [activeTab, iomList]);

    useEffect(() => {
        const fetchData = async () => {
            const iomlistfilter = await getIOMList();
            const storedTab = localStorage.getItem("activeTab") || "drafted";
            setActiveTab(storedTab);
        };

        fetchData();
    }, []);


    const handleTabClick = (tabName, callback) => {
        localStorage.setItem("activeTab", tabName);
        setActiveTab(tabName);
        callback();
    };


    return (<>
        <div className="content">
            {/* Filters */}
            <div className="card filter">
                <div className="card-body">
                    <div className="row">
                        <div className='col-lg-2 col-md-3 col-sm-12'>
                            <label>
                                From
                            </label>
                            <DateBox
                                placeholder="Select date"
                                value={filters?.fromDate}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("fromDate", e?.value)
                                }
                                }
                                displayFormat="dd/MM/yyyy"
                            />
                            {filterErrors?.fromDate && <span className="error invalid-feedback">{filterErrors?.fromDate}</span>}
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-12'>
                            <label>
                                To
                            </label>
                            <DateBox
                                placeholder="Select date"
                                value={filters?.toDate}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("toDate", e?.value)
                                }}
                                displayFormat="dd/MM/yyyy"
                            />
                            {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>}
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-12'>
                            <label>
                                Status <span className="text-danger"></span>
                            </label>
                            <SelectBox
                                //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                dataSource={iomStatusDropdownData}
                                valueExpr="id"
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select status"
                                searchEnabled
                                showClearButton={false}
                                value={filters?.statusId}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("statusId", e?.value)
                                }}
                            />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-12'>
                            <label>
                                IOM # <span className="text-danger"></span>
                            </label>
                            <SelectBox
                                //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                dataSource={iomNoDropdownData}
                                valueExpr="id"
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select IOM no"
                                searchEnabled
                                showClearButton={false}
                                value={filters?.iomNo}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("iomNo", e?.value)
                                }}
                            />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-12'>
                            <label>
                                Project <span className="text-danger"></span>
                            </label>
                            <SelectBox
                                //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                dataSource={projectDropdownData}
                                valueExpr="id"
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select project"
                                searchEnabled
                                showClearButton={false}
                                value={filters?.projectId}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("projectId", e?.value)
                                }}
                            />
                        </div>
                        <div className='col-lg-2 col-md-3 col-sm-12'>
                            <label style={{ display: "block" }}>&nbsp;</label>
                            <button
                                className="btn btn-primary btn-sm mt-2 mr-2"
                                title='Filter'
                                tooltip='Filter'
                                onClick={getIOMList}
                            >
                                <Icon className='iconify-size mr-1' icon="hugeicons:filter" />
                                Filter
                            </button>
                            <button
                                className="btn btn-outline-primary btn-sm mt-2"
                                title='Clear'
                                tooltip='Clear'
                                onClick={() => {
                                    setFilters(prevState => {
                                        return {
                                            ...prevState,
                                            fromDate: "",
                                            toDate: "",
                                            projectId: 0,
                                            statusId: 0,
                                            iomNo: 0,
                                        }
                                    })
                                    getIOMList(true);
                                }}
                            >
                                <Icon className='iconify-size mr-1' icon="hugeicons:eraser" />
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card'>
                <div className='card-body'>
                    <DataGrid
                        dataSource={iomList}
                        className='iom-grid'
                        columnAutoWidth
                        showBorders
                        showColumnLines={false}
                        showRowLines={true}
                        allowFiltering
                        columnHidingEnabled
                        onToolbarPreparing={(e) => {
                            e.toolbarOptions.items.unshift({
                                location: "before",
                                widget: "dxButton",
                                options: {
                                    icon: "refresh",
                                    text: "Refresh",
                                    type: "default",
                                    stylingMode: "outlined",
                                    onClick: () => getIOMList(),
                                    hint: "Refresh",
                                }
                            });
                            e.toolbarOptions.items.unshift({
                                location: "before",
                                widget: "dxButton",
                                visible: (props?.isAllowedForThisRole || props?.featurePermission?.canAdd) ? true : false,
                                options: {
                                    icon: "plus",
                                    text: "New",
                                    type: "default",
                                    stylingMode: "contained",
                                    onClick: () => navigate("/new-inter-office-memo"),
                                    hint: "New",
                                }
                            });
                        }}
                    >
                        <Column
                            width="95px"
                            cellRender={(cellData) => {
                                const rowData = cellData?.data;
                                return (
                                    <>
                                        {/* View */}
                                        <span title='View'>
                                            <Icon
                                                title="View"
                                                className='iconify-size mr-1'
                                                icon="solar:document-text-outline"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() =>
                                                    navigate("/iom-preview", { state: { iomId: rowData?.iomId, isPreviewOnly: true } })
                                                }
                                            />
                                        </span>
                                        {/* Edit */}
                                        {((rowData?.createdByUserId === user?.userId && rowData?.iomStatusId === 4) ||
                                            rowData?.iomStatusId === 8 || rowData?.iomStatusId === 5) ? (
                                            <span title="Edit">
                                                <Icon
                                                    title="Edit"
                                                    className='iconify-size mr-1'
                                                    icon="solar:pen-line-duotone"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                        navigate(
                                                            rowData?.isManual
                                                                ? "/new-inter-office-memo-old"
                                                                : "/new-inter-office-memo",
                                                            { state: rowData }
                                                        )
                                                    }
                                                />
                                            </span>
                                        ) : (
                                            <span>
                                                <Icon
                                                    title="Edit"
                                                    className='iconify-size'
                                                    icon="solar:pen-line-duotone"
                                                    style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                />
                                            </span>
                                        )}
                                        {/* Delete */}
                                        {rowData?.createdByUserId === user?.userId && (rowData?.iomStatusId === 8 || rowData?.iomStatusId === 4) ? (
                                            <span title="Delete">
                                                <Icon
                                                    title="Delete"
                                                    className='iconify-size'
                                                    icon="fluent:delete-32-regular"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setIOMId(rowData?.iomId);
                                                        setIsDeleteModalVisible(true);
                                                        // navigate("/inter-office-memo");
                                                    }}
                                                />
                                            </span>
                                        ) : (
                                            <span>
                                                <Icon
                                                    title="Delete"
                                                    className='iconify-size'
                                                    icon="fluent:delete-32-regular"
                                                    style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                />
                                            </span>
                                        )}

                                    </>
                                );
                            }}
                        />
                        <Column dataField="serial_no" allowSearch={true} caption="IOM No." width='250px' allowFiltering={false} />
                        <Column
                            // dataField="nextUserStatusText"
                            caption="Status"
                            allowSearch={true}
                            calculateCellValue={(cellData) => `${cellData?.iomStatusId === 8 ? "Drafted"
                                : cellData?.iomStatusId === 4 ? "Revised Draft"
                                    : cellData?.nextUserStatusText ?? "Approved"
                                }
                                ${cellData?.nextUser?.trim() === "" ? cellData?.lastUpdatedByUser : cellData?.nextUser}
                                `

                            }
                            cellRender={(e) => {
                                let color = '#28A745';
                                if (e.data?.nextUserStatusId === 4) color = 'gray';
                                else if (e.data?.nextUserStatusId === 1) color = '#ff9800';
                                else if (e.data?.nextUserStatusId === 2) color = '#FF9800';
                                else if (e.data?.nextUserStatusId === 3) color = 'orange';
                                else if (e.data?.nextUserStatusId === 7) color = '#ff9800';
                                return (
                                    <div>
                                        {(e.data?.iomStatusId === 8) ? (
                                            <span style={{ color: '#6C757D' }}>Drafted</span>
                                        ) : (e.data?.iomStatusId === 4) ? (
                                            <span style={{ color: '#DC3545' }}>Revised Draft</span>
                                        ) : (e.data?.iomStatusId === 9) ? (
                                            <span style={{ color: '#DC3545' }}>Recall Requested</span>
                                        ) : (
                                            <span style={{ color }}>{e?.data?.nextUserStatusText ?? "Approved"}</span>
                                        )}
                                        <div style={{ color: '#b1b1b1', fontSize: '11px' }}>
                                            {e.data?.nextUser?.trim() === "" ? e.data?.lastUpdatedByUser : e.data?.nextUser}
                                        </div>
                                    </div>
                                );
                            }}
                        />
                        <Column
                            caption="From"
                            allowSearch={true}
                            calculateCellValue={(cellData) => `${cellData?.fromUser || ""} ${cellData?.fromUserDepartment || ""}`}
                            cellRender={(e) => (
                                <div>
                                    <div>{e.data.fromUser}</div>
                                    <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.fromUserDepartment}</div>
                                </div>
                            )}
                        />
                        <Column
                            caption="To"
                            dataField="toUser"
                            allowFiltering={false}
                            allowSearch={true}
                            calculateCellValue={(cellData) => `${cellData?.toUser || ""} ${cellData?.toUserDepartment || ""}`}
                            cellRender={(e) => (
                                <div>
                                    <div>{e.data.toUser}</div>
                                    <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.toUserDepartment}</div>
                                </div>
                            )}
                        />
                        <Column
                            dataField="subject"
                            caption="Subject"
                            allowFiltering={false}
                            allowSearch={true}
                            calculateCellValue={(cellData) => `${cellData?.subject}`}
                            cellRender={(cellData) => (
                                <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                                    {cellData.value}
                                </div>
                            )}
                        />
                        <Column dataField="projectName" caption="Project" allowFiltering={false} allowSearch={true} />
                        <Column dataField="categoryName" caption="Category" allowFiltering={false} allowSearch={true} />
                        <Column
                            dataField="iomDate"
                            caption="Created On"
                            width="150px"
                            allowFiltering={false}
                            allowSearch={true}
                            calculateCellValue={(cellData) => {
                                const date = new Date(cellData?.iomDate);
                                return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`
                            }}
                            cellRender={(e) => {
                                const date = new Date(e.data.iomDate);
                                return (
                                    <>
                                        <div>
                                            {date.toLocaleDateString('en-GB')}&nbsp;
                                            {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data?.fromUser}</div>
                                        </div>
                                    </>
                                );
                            }}
                        />
                        <Column
                            dataField="lastUpdatedOn"
                            caption="Last Updated"
                            allowFiltering={false}
                            width="150px"
                            allowSearch={true}
                            calculateCellValue={(cellData) => {
                                const date = new Date(cellData?.lastUpdatedOn);
                                return `${date.toLocaleDateString('en-GB')}
                                ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                ${cellData?.lastUpdatedByUser}`
                            }}
                            cellRender={(e) => {
                                if (!e.data.lastUpdatedOn) return null;
                                const date = new Date(e.data.lastUpdatedOn);
                                return (
                                    <div>
                                        {date.toLocaleDateString('en-GB')}&nbsp;
                                        {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                        <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data.lastUpdatedByUser}</div>
                                    </div>
                                );
                            }}
                        />
                        <HeaderFilter visible={true} />
                        <LoadPanel
                            //shadingColor="rgba(179, 34, 34, 0.4)"
                            //position={position}
                            visible={loading}
                            showIndicator={true}
                            //shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <SearchPanel
                            visible={true}
                            highlightCaseSensitive={false}
                            highlightSearchText={true}
                            width={240}
                            placeholder="Search..."
                        />
                        <LoadPanel
                            //shadingColor="rgba(179, 34, 34, 0.4)"
                            //position={position}
                            visible={loading}
                            showIndicator={true}
                            //shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <Paging defaultPageSize={15} />
                        <Pager
                            visible={true}
                            allowedPageSizes={[10, 15, 20, 50, 100]}
                            showPageSizeSelector={true}
                            showInfo={true}
                            showNavigationButtons={true}
                        />
                        <Export enabled={false} fileName="IOM" />
                    </DataGrid>
                    {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </div>
        {/* </div> */}
        <Popup
            visible={isDeleteModalVisible}
            onHiding={() => setIsDeleteModalVisible(false)}
            dragEnabled={false}
            showTitle={true}
            title="Delete"
            height="auto"
            weight="auto"
            className='custom-modal-popup'
        >
            <div className='popup-body'>
                <label>Remark <span className="text-danger">*</span></label>
                <div className='form-group'>
                    <TextArea
                        value={remarks}
                        onInput={(e) => handleRemarksChange(e)}
                        height={90}
                        placeholder="Type your remarks..."
                        maxLength={300}
                    />
                    <div style={{ fontSize: "12px", color: charCount > 300 ? "red" : "#999" }}>
                        {charCount}/300 characters
                    </div>
                    {error?.remarks && (
                        <div style={{ color: "red", marginTop: 5 }}>{error?.remarks}</div>
                    )}
                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsDeleteModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleSubmit}
                        className="btn btn-primary btn-sm"
                    />
                </div>
            </div>
        </Popup>
    </>
    )
}




